export const abnormal = {
    data() {
        return {
            dataSource: [{
                serialNum: 1,
                productName: "商品1",
                code: "aaa123456",
                voucherDate: "2020-3-23",
                transactorName: "张三",
                totalAmount: "20.00",
                shouhuoren: "莉丝",
                fahuomendian: "萧山门店",
                shuliang: 120,
                beizhu: "",
                status: 1,
                operation: ""
            }, {
                serialNum: 1,
                productName: "商品1",
                code: "aaa123456",
                voucherDate: "2020-3-23",
                transactorName: "张三",
                totalAmount: "20.00",
                shouhuoren: "莉丝",
                fahuomendian: "萧山门店",
                shuliang: 120,
                beizhu: "",
                status: 2,
                operation: ""
            }, {
                serialNum: 1,
                productName: "商品1",
                code: "aaa123456",
                voucherDate: "2020-3-23",
                transactorName: "张三",
                totalAmount: "20.00",
                shouhuoren: "莉丝",
                fahuomendian: "萧山门店",
                shuliang: 120,
                beizhu: "",
                status: 3,
                operation: ""
            }, {
                serialNum: 1,
                productName: "商品1",
                code: "aaa123456",
                voucherDate: "2020-3-23",
                transactorName: "张三",
                totalAmount: "20.00",
                shouhuoren: "莉丝",
                fahuomendian: "萧山门店",
                shuliang: 330,
                beizhu: "",
                status: 4,
                operation: ""
            }, {
                serialNum: 1,
                productName: "商品12222",
                code: "aaa123456",
                voucherDate: "2020-3-23",
                transactorName: "里斯",
                totalAmount: "20.00",
                shouhuoren: "卡收",
                fahuomendian: "萧山门店",
                shuliang: 1230,
                beizhu: "",
                status: 5,
                operation: ""
            }, {
                serialNum: 1,
                productName: "商品商品商品",
                code: "aaa123456",
                voucherDate: "2020-3-23",
                transactorName: "张三",
                totalAmount: "203.00",
                shouhuoren: "丽萨",
                fahuomendian: "萧山门店",
                shuliang: 1200,
                beizhu: "",
                status: 5,
                operation: ""
            }],
            ipagination: {
                current: 1,
                pageSize: 10,
                showTotal: (total, range) => {
                    return range[0] + "-" + range[1] + " 共" + total + "条"
                },
                showQuickJumper: true,
                showSizeChanger: true,
                total: 100
            },
            contentHeight: '',
            tableHeight: ''
        }
    },
    methods: {
        init() {
            // 表格高度计算
            let _that = this
            setTimeout(function() {
                let tdHeight = document.getElementsByTagName('tr')[0].offsetHeight
                let header = document.getElementById("header").offsetHeight;
                let breadcrumb = document.getElementById("breadcrumb").offsetHeight;
                let pageHeight = document.getElementById('content').offsetHeight
                let makeTop = document.getElementById('page-top').offsetHeight
                let tabsTitleHeight = document.getElementsByClassName('ant-tabs-top-bar')[1].offsetHeight
                _that.contentHeight = pageHeight - makeTop - header - breadcrumb - tdHeight * 0.8
                _that.tableHeight = _that.contentHeight - tdHeight - tabsTitleHeight
            }, 50)
            this.getMenuList()
                // this.getStorageList()
                // this.getStaffListSelect()
        },
        // 页面变化时回调
        onChangeIpagination(current) {
            this.ipagination.current = current
            this.getMenuList()
        },
        // 一页显示条数变化时回调
        onShowSizeChange(current, pageSize) {
            this.ipagination.current = current
            this.ipagination.pageSize = pageSize
            this.getMenuList()
        },
        // 重置数据
        btnResetData() {
            this.dateValue = null
            this.ipagination.current = 1
            this.ipagination.pageSize = 10
            this.formData.confirmFlag = null
            this.formData = {
                contactCustomerName: ''
            }
            this.getMenuList()
        },
        // 筛选
        btnInquire() {
            this.ipagination.current = 1
            this.ipagination.pageSize = 10
            this.getMenuList()
        },
        // 切换类型
        callback(e) {
            this.ipagination.current = 1
            this.ipagination.pageSize = 10
            if (e == 1) {
                this.formData.confirmFlag = null
            } else if (e == 2) {
                this.formData.confirmFlag = 0
            } else if (e == 3) {
                this.formData.confirmFlag = 1
            }
            this.getMenuList()
        },
        // 获取表格数据
        getMenuList() {}
    }
}